<template>
    <div>
        <div v-if="delete_loader" class="checkoutLoader">
               <div class="LoaderPlacement">
                    <div class="digi-table-loader">
                         <div></div>
                         <div></div>
                         <div></div>
                         <div></div>
                    </div>
               </div>
          </div>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <ul class="d-flex align-items-center pl-4 mb-0">
                <li class="d-flex align-items-center employee_list_active">
                        <span class="list-text">QR Code</span>
                        <span class="mx-2">|</span>
                        <span class="list-text-count">{{total}} Total</span>
                </li>
            </ul>
            <div class="d-flex align-items-center">
                <button @click="CreateQrCodeModal" style="width:180px" class="btn btn-success text-white text-capitalize">
                    Add New QR Code
                </button>
                <button class="btn btn-print text-capitalize ml-3" style="border-radius: 5px !important" @click="PrintAllQrCodeModal">
                    <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/printer.svg" class="w-18">
                    Print All QR Code
                </button>
            </div>
        </div>
        <div class="table-content mb-3" style="overflow-x: auto !important;">
            <table class="table table-content-data table-responsive" style="border: solid 0.5px #f2f3f5;border-radius: 8px;">
                <thead>
                        <tr>
                            <th class="whiteSpace w-1">
                                Facility Name
                            </th>
                            <!-- <th class="whiteSpace w-1">
                                QR code
                            </th> -->
                            <th class="whiteSpace w-1">
                                Location
                            </th>
                            <th class="whiteSpace w-1">
                                View QR Code
                            </th>
                            <th class="whiteSpace w-1">
                                Activate
                            </th>
                            <th class="whiteSpace w-1"></th>
                        </tr>
                </thead>
                <tbody>
                        <tr v-if="ajax_call_in_progress" class="text-center">
                            <td colspan="8">
                                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center position-relative"/>
                            </td>
                        </tr>
                        <tr v-if="!ajax_call_in_progress && list_data.length == 0" class="text-center ht-100px">
                            <td colspan="8" class="text-center fw-600">No Data Found</td>
                        </tr>
                        <tr v-else v-for="(data, index) in list_data" :key="index+'list_data'"  class="text-center">
                            <td class="whiteSpace w-1 text-capitalize">
                                {{data.facility_name || '-'}}
                            </td>
                            <!-- <td class="whiteSpace w-1 ">
                                {{data.qr_code || '-'}}
                            </td> -->
                            <td class="whiteSpace w-1">
                                <span :title="data.location || '-'" class="d-block w-100 table-large-text">
                                    {{data.location || "-"}}
                                </span>
                            </td>
                            <td class="whiteSpace w-1 text-capitalize">
                                <i v-if="data.status" class="icon icon-eye color-blue pointer" @click="ViewQrCode(data, 'view')"></i>
                                <i v-else class="icon icon-eye color-blue pointer pointer-event" style="pointer-events: auto;"></i>
                            </td>
                            <td class="whiteSpace w-1">
                                <el-switch v-model="data.status" @change="changeStatus($event, data)"></el-switch>
                            </td>
                            <td class="whiteSpace w-1">
                                <span class="pointer whiteSpace buttons action-btns-show-hide">
                                    <button :disabled="!data.status" class="btn btn-icon color-purple actionicons view" style="height: 25px;padding: 5px !important;" @click="ViewQrCode(data, 'print')" >
                                        <el-tooltip class="item position-relative" effect="dark" content="Print" style="bottom: 4.5px;" placement="top">
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/printer.svg" class="w-18">
                                        </el-tooltip>
                                    </button>
                                    <button class="btn btn-icon actionicons update ml-3" style="height: 25px;padding: 5px !important;" @click="deleteQrCodeConfirm(data._id)">
                                        <el-tooltip class="item" effect="dark" content="Delete" style="bottom: 4.5px;" placement="top">
                                            <i class="icon icon-trash deleteIcon"></i>
                                        </el-tooltip>
                                    </button>
                                </span>
                            </td>
                        </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex align-items-center font-weight-bold mt-2 justify-content-end" v-if="total > 0">
            <multiselect class="diginew-multiselect dd-ht multiple-select-arrow-hide"
                :options="pageLimit" :close-on-select="true" v-model.number="limit"
                @search-change="fetchListData"
                open-direction="top" :show-labels="false" placeholder=""
                style="width: 5.3em !important;padding-right: 10px!important;"></multiselect>
            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg"
                style="margin-left: -35px;">
            <span class="page-info pr-2 pl-6 fw-500"
                style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
            <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                    <i class="icon-chevron-double-left"></i>
                </el-tooltip>    
            </button>
            <button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                    <i class="icon icon-chevron-left"></i>
                </el-tooltip>    
            </button>
            <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
            <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list mt-1 mr-2 pointer">
                <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                    <i class="icon icon-chevron-right"></i>
                </el-tooltip>    
            </button>
            <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total+10 >= total">
                <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                    <i class="icon-chevron-double-right"></i>
                </el-tooltip>    
            </button>
        </div>
        <!-- <div>
            <div class="row">
                <div class="col-md-12">
                        <div class="float-right">
                            <span class=" fs-14 pointer d-block" @click="CreateQrCodeModal">
                                + Add New QR Code
                            </span>
                        </div>
                </div>
            </div>
        </div> -->
    <add-new-qr-code v-if="qrcodemodal" @saveSuccess="saveSuccess" @hide-add-qrcode-modal="HideAddNewQrCodeModal"  modal_name="AddQrCodeModal"></add-new-qr-code>
    <view-qr-code v-if="viewqrcode" :qr_code_type="qr_code_type" @hide-view-qr-code="HideViewQrCode" :qr_cde="qr_cde" :qr_code_name="qr_code_name" modal_name="ViewQrCode"></view-qr-code>
    <print-all-qr-code v-if="printallqrcode" @hide-print-all-qr-code="HidePrintAllQrCode" :qr_code_data="qr_code_data"  modal_name="PrintAllQrCodeModal"></print-all-qr-code>
    <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
    <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import AddNewQrCode from './AddNewQrCode'
import ViewQrCode from './ViewQrCode'
import PrintAllQrCode from './PrintAllQrCode'
import facility_mgmt from '../../mixins/facility_mgmt';
import global from '../../global';
import Swal from 'sweetalert2';
export default({
    mixins: [facility_mgmt],
    data(){
        return{
            activate: false,
            qrcodemodal: false,
            viewqrcode: false,
            printallqrcode: false,
            list_data: [],
            success_msg: '',
            warning_msg: '',
            qr_cde: '',
            qr_code_type: '',
            qr_code_name: '',
            qr_code_data: [],
            skip:0,
            limit:10,
            total:0,
            temp_total:0,
            search_key:'',
            pageLimit: [],
            skip_temp: 0,
            count:0,
            data_loader: false,
            pageLimit: [],
        }
    },
    components: {
        AddNewQrCode,
        ViewQrCode,
        PrintAllQrCode,
        SweetModal,
        Swal
    },
    methods:{
        CreateQrCodeModal(){
            this.qrcodemodal = true
            setTimeout(() => {
                this.$modal.show('AddQrCodeModal')
            }, 500);
        },
        HideAddNewQrCodeModal(){
            this.qrcodemodal = false
            setTimeout(() => {
                this.$modal.hide('AddQrCodeModal')
            }, 500);
        },
        saveSuccess() {
            this.fetchListData();
        },
        ViewQrCode(qr_code, type){
            this.qr_code_type = type;
            this.qr_code_name = qr_code.location;
            this.viewqrcode = true
            this.qr_cde = global.HELP_URL + '/facilitymanagement/securityconcern/create?facility_id='+qr_code.facility_id;
            setTimeout(() => {
                this.$modal.show('ViewQrCode')
            }, 500)
        },
        HideViewQrCode(){
            this.viewqrcode = false
        },
        PrintAllQrCodeModal(){
            this.qr_code_data = [];
            this.list_data.forEach((element, index) => {
                if(element.status == true) {
                    this.qr_code_data.push({
                        link: global.HELP_URL + '/facilitymanagement/securityconcern/create?facility_id='+element.facility_id,
                        qr_code: element.location,
                    })
                }
            });
            this.printallqrcode = true
            setTimeout(() => {
                this.$modal.show('PrintAllQrCodeModal')
            }, 500)
        },
        HidePrintAllQrCode(){
            this.printallqrcode = false
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.list_data = []
            this.fetchListData()
        },
        lastPage(){
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.fetchListData();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.fetchListData();
        },
        previousPage() {
            this.skip_temp = 0
            this.temp_total = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.fetchListData();
        },
        async fetchListData() {
            this.list_data = [];
            this.ajax_call_in_progress = true;
            try {
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key.trim(),
                };
                let response = await this.getQrCodeList(params);
                this.list_data = response.response.qr_code_list;
                this.total = response.response.count;
                this.ajax_call_in_progress = false;
            } catch (error) {
                this.warning_msg = error;
                this.$refs.warning_modal.open();
                setTimeout(() => {
                        this.$refs.warning_modal.close();
                }, 3000);
                this.ajax_call_in_progress = false;
            }
        },
        deleteQrCodeConfirm(id){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to delete ?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonColor:'#00448b',
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.isConfirmed == true) {
                    this.deleteQrCode(id)
                }
            })
        },
        async deleteQrCode(id) {
            this.delete_loader = true
            try {
                let params = {
                    qr_code_id: id,
                };
                let response = await this.deleteQrCodeById(params);
                this.success_msg = response.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.delete_loader = false
                    this.$refs.success_modal.close();
                    this.fetchListData();
                }, 3000);
            }
            catch (error) {
                this.delete_loader = false
                this.warning_msg = error;
                this.$refs.warning_modal.open();
            }
        },
        async changeStatus(event, data) {
            try {
                let params = {
                        qr_code_id: data._id,
                        status: event
                };
                let response = await this.updateQrCode(params);
                this.success_msg = response.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.fetchListData();
                }, 3000);
            }
            catch (error) {
                this.warning_msg = error;
                this.$refs.warning_modal.open();
                setTimeout(() => {
                        this.$refs.warning_modal.close();
                }, 3000);
            }
        }
    },
    mounted(){
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        this.fetchListData();
    },
    watch: {
        limit: function(){
            this.fetchListData();
        }
    },
    computed: {
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
    }
})
</script>

<style scoped>
    table td{
        text-align: left;
    }
    .list-text {
        font-size: 14px;
        font-weight: 500;
        font-weight: 600;
        color: #000;
    }

    .list-text-count {
        font-size: 14px;
        font-weight: 500;
        font-weight: 600;
        color: rgba(54, 54, 54, 0.61);
    }
    .btn-print{
        border-radius: 18px !important;
        background: #ab33ea;
        color: #fff;
    }
    .color-purple{
        background: #ab33ea;
    }
    .color-blue{
        color: #005dae;
    }
    .table-large-text{
        max-width: 280px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .ht-100px{
        height: 100px;
    }
</style>
